import React, { FC } from 'react';
import styled from 'styled-components';
import { MrpCodeBadge } from '../../components/mrp-code-badge/mrp-code-badge';
import { IPlantTransaction } from '../../graphql/types';
import { Grey2 } from '../../styles/colours';
import { DemiBold, Medium } from '../../styles/fonts';

const StyledContainer = styled.div`
  display: inline-flex;
`;

const StyledTitle = styled.span`
  color: ${Grey2};
  font-size: 0.875rem;
  font-family: ${DemiBold};
  padding: 0rem 0.3rem 0rem 1.25rem;
`;

const StyledText = styled.div`
  font-size: 1.125rem;
  font-family: ${Medium};
`;

const StyledBorder = styled.div`
  border-right: 0.1rem solid ${Grey2};
  padding-right: 1.5rem;
`;

export const StockDetails: FC<{ stock: IPlantTransaction }> = ({ stock }) => {
  return (
    <StyledContainer>
      <StyledBorder>
        <MrpCodeBadge variant={stock.mrpElement}>
          {stock.mrpElement}
        </MrpCodeBadge>
      </StyledBorder>
      <StyledTitle>Receipt Req: </StyledTitle>
      <StyledBorder>
        <StyledText>{stock.requiredQuantity}</StyledText>
      </StyledBorder>
      <StyledTitle>Availabile: </StyledTitle>
      <StyledText>{stock.calculatedQuantity}</StyledText>
    </StyledContainer>
  );
};
